import {ShopSellerInformationModel, ShopSellerListItem} from '../models/shop-seller/shop-seller.model';

/**
 * Sellers read from the VTEX master data are identified by their document id (GUID).
 * Sellers read from the application database keep using the numeric id.
 */
export function isMasterDataSeller(seller: Pick<ShopSellerListItem | ShopSellerInformationModel, 'source'> | null | undefined): boolean {
  return seller?.source === 'MasterData';
}

export function getShopSellerRouteId(seller: ShopSellerListItem): string | number {
  return isMasterDataSeller(seller) && seller.documentId ? seller.documentId : seller.id;
}